import { StyleSheet } from 'react-native';

import { EPGConfig } from '../../types';

const getStyles = (config: EPGConfig) =>
    StyleSheet.create({
        container: {
            height: config.rowHeight,
            marginBottom: config.padding,
            alignItems: 'stretch',
            justifyContent: 'center',
            overflow: 'hidden',
        },
    });

export default getStyles;
